export enum Layer3dType {
    SYSTEM,
    CUSTOM,
    POINTCLOUD,
}
